import { Component, ViewChild, AfterViewInit } from '@angular/core';
import { InfoDialogComponent } from '../../shared/components/info-dialog/info-dialog.component';

@Component({
    selector : 'forbidden',
    templateUrl : 'forbidden.component.html',
    styleUrls : ['forbidden.component.scss']
})
export class ForbiddenComponent {

}
